import React from 'react';
import { useTranslation } from 'react-i18next';
import './UniversalVoucherServicestTranslate'
import paths from '../../_helpers/paths';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { getContentWidth } from '../../utils/getContentWidth';
import { Content } from '../../components/ThemeProvider/ThemeStyle';
import {StyledBreadCrumbs, StyledContent} from "./UniversalServicesStyle";
import UniversalVoucherServicesInsert from './section/UniversalVoucherServicesInsert';
import UniversalVoucherServicesQuestions from './section/UniversalVoucherServicesQuestions';


function UniversalVoucherServices() {
    const { t } = useTranslation();
    const breadCrumbItems = [];
    breadCrumbItems.push({ name: t('home_subtitle'), href: paths.homePage });
    breadCrumbItems.push({ name: t('kindergarten_org_subtitle') });
    const contentWidth = getContentWidth('/universal-voucher-services');
    return (
        <div style={{width: '100%'}}>
            <StyledContent>
                <StyledBreadCrumbs>
                    <Content contentWidth={contentWidth}>
                        <BreadCrumbs items={breadCrumbItems} />
                    </Content>
                </StyledBreadCrumbs>
                <UniversalVoucherServicesInsert contentWidth={contentWidth} />
            </StyledContent>
            {/*<KindergartenOurService contentWidth={contentWidth} />*/}
            <UniversalVoucherServicesQuestions contentWidth={contentWidth} />
            {/*<KindergartenUsefulArticles contentWidth={contentWidth} />*/}
        </div>
    );
}

export default UniversalVoucherServices;
